module.exports = __webpack_public_path__ + "img/preview-desktop.84228a81.svg";